var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.pageTitle))]),(_vm.descTitle)?_c('p',[_vm._v(_vm._s(_vm.descTitle))]):_vm._e(),(_vm.tableDataInput)?_c('Table',{attrs:{"table-data-input":_vm.tableDataInput}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }